<script lang="ts">
  import { page } from '$app/stores';
  import type { Race, RacesResponse } from '$types/races';
  import { getRaceLink, gotoRace, selectedRaceId } from '$utils/navigation';
  import { isRaceClosed } from '$utils/race';
  import { createMenu } from 'svelte-headlessui';
  import { Transition } from 'svelte-transition';
  import TablerChevronDown from '~icons/tabler/chevron-down';
  import { scrollToActiveRace } from './RaceList.svelte';
  import { selectedRace } from '$lib/stores';

  $: ({ races, race, streamed } = $page.data);

  $: racesInMeeting =
    $races?.data?.races.filter((r) => {
      return (
        r.meeting.date === $race?.meeting.date &&
        r.meeting.type[0] === $race.meeting.type[0] &&
        r.meeting.track === $race.meeting.track
      );
    }) ?? [];

  const popover = createMenu({ label: 'Race Pagination' });

  function raceStatusClass(raceNumber: number) {
    const cls = '';
    const r = racesInMeeting.find((r) => r.number === raceNumber);
    if (r && isRaceClosed(r)) {
      return cls + 'bg-gray-200/70 hover:bg-gray-200';
    } else if (race && $race && raceNumber === $race.number) {
      return cls + 'text-gray-900 bg-gray-50 hover:bg-gray-100';
    } else {
      return cls + 'bg-white text-gray-800 hover:bg-gray-50';
    }
  }
  function handleClick(r: Race) {
    popover.close();
    if (r.id === $selectedRaceId) return;
    if (streamed) streamed.raceData = undefined;
    selectedRaceId.set(r.id);
    $scrollToActiveRace();
  }
</script>

<div class="relative">
  {#if $selectedRace}
    <div use:popover.button class="md:hidden">
      <button
        class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
      >
        <span>R{$selectedRace.number}</span>
        <TablerChevronDown class="-mr-1 ml-2 h-5 w-5" />
      </button>
    </div>

    <Transition
      show={$popover.expanded}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <div
        use:popover.items
        class="absolute z-40 mt-2 w-full divide-y divide-gray-100 rounded-md bg-white p-2 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
      >
        {#each racesInMeeting as item}
          {@const active = $selectedRace.number === item.number}
          <a
            href={getRaceLink(item)}
            on:click={() => {
              handleClick(item);
            }}
            on:keypress={() => {
              handleClick(item);
            }}
            use:popover.item
            class="group flex w-full items-center justify-center rounded-md p-3 text-sm {active
              ? 'border border-gray-300 bg-gray-200 text-gray-900'
              : 'text-gray-900'}"
          >
            R{item.number}
          </a>
        {/each}
      </div>
    </Transition>
  {/if}
</div>
<div
  class="relative z-0 mt-2 hidden flex-nowrap -space-x-px overflow-x-hidden pl-2 md:ml-4 md:mt-0 md:flex"
>
  {#each racesInMeeting as r (r.id)}
    <a
      on:click={() => handleClick(r)}
      on:keypress={() => handleClick(r)}
      href={getRaceLink(r)}
      class="{r.id === $selectedRaceId
        ? 'border-1 z-10 border-black/60 bg-gray-900 font-bold  text-white  hover:bg-gray-800'
        : 'border-gray-300 font-medium text-black'}
				relative inline-flex items-center border px-4 py-2 text-sm {raceStatusClass(
        r.number
      )} {r.number == racesInMeeting[0].number
        ? 'rounded-l-md'
        : r.number === racesInMeeting[racesInMeeting.length - 1].number
          ? 'rounded-r-md'
          : ''}"
    >
      {r.number}
    </a>
  {/each}
</div>
